import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Shell } from "./_shell";

export default function LowStock() {
  const [rows, setRows] = useState([]);
  const [defaultThreshold, setDefaultThreshold] = useState(10);
  const [loading, setLoading] = useState(true);
  const load = () => {
    setLoading(true);
    api.get("/admin/low-stock").then(r => {
      setRows(r.data.items || []);
      setDefaultThreshold(r.data.default_threshold ?? 10);
    }).catch(() => setRows([])).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);
  return (
    <Shell active="lowstock">
      <div className="p-5 md:p-10">
        <div className="overline mb-2">Reorder alerts</div>
        <h1 className="font-display text-4xl md:text-6xl uppercase leading-none mb-4">Low stock.</h1>
        <p className="text-sm text-black/60 mb-6 max-w-2xl">
          Every product listed here is at or below its low-stock threshold. Restock via the Inventory Excel before you hit out-of-stock.
          Set a per-product threshold from the product form, or a site-wide default in <Link to="/admin/settings" className="underline">Website Settings</Link>.
          Current default: <b>{defaultThreshold}</b> unit{defaultThreshold === 1 ? "" : "s"}.
        </p>
        <div className="border border-ink overflow-x-auto" data-testid="lowstock-table">
          <table className="w-full text-sm min-w-[720px]">
            <thead>
              <tr className="border-b border-ink bg-ink text-paper">
                <th className="text-left p-3 overline">Product</th>
                <th className="text-left p-3 overline">Category</th>
                <th className="text-right p-3 overline">Stock</th>
                <th className="text-right p-3 overline">Threshold</th>
                <th className="text-right p-3 overline">Delta</th>
                <th className="text-right p-3 overline"></th>
              </tr>
            </thead>
            <tbody>
              {rows.map(r => {
                const critical = r.stock_quantity === 0;
                const cls = critical ? "text-soda font-bold" : r.delta < 0 ? "text-safety font-bold" : "";
                return (
                  <tr key={r.id} className="border-b border-black/10" data-testid={`lowstock-${r.id}`}>
                    <td className="p-3">
                      <div className="font-bold">{r.name}</div>
                      {r.brand && <div className="text-xs text-black/60">{r.brand}</div>}
                    </td>
                    <td className="p-3 text-xs">{r.category_slug}</td>
                    <td className={`p-3 text-right ${cls}`} data-testid={`lowstock-stock-${r.id}`}>{r.stock_quantity}</td>
                    <td className="p-3 text-right">{r.threshold}</td>
                    <td className={`p-3 text-right ${cls}`}>{r.delta > 0 ? `+${r.delta}` : r.delta}</td>
                    <td className="p-3 text-right">
                      <Link to="/admin/products" className="text-[11px] underline" data-testid={`lowstock-edit-${r.id}`}>Edit product</Link>
                    </td>
                  </tr>
                );
              })}
              {rows.length === 0 && !loading && (
                <tr><td colSpan="6" className="p-8 text-center text-black/50">Everything is above threshold. 🎉</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Shell>
  );
}
